/* @flow */

import Edit from './Edit';
import View from './View';

export type NavigationContentLink = {
  order?: number,
  title?: string,
  page: CatalogPage,
  image?: CatalogResource,
};

export type NavigationContent = {
  items: Array<NavigationContentLink>,
};

export const getEditComponent = () => Edit;
export const getViewComponent = () => View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/nav/simple/index.js